import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { createFileRoute } from "@tanstack/react-router";
import { Hand, Mail, MousePointerClick, Navigation, ShoppingBag, Truck } from "lucide-react";
import { SupportStepRow } from "~/components/SupportStepRow";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";

export const Route = createFileRoute("/support/how-to-use/click-and-collect")({
	beforeLoad: () => {
		document.title = "bacehub | Chat & Support";
	},
	component: RouteComponent,
});

export default function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];
	const steps = [
		{
			icon: ShoppingBag,
			title: i18n.SHOP_AS_USUAL(),
			description: i18n.SHOP_AS_USUAL_DESC(),
		},
		{
			icon: MousePointerClick,
			title: i18n.SELECT_CLICK_AND_COLLECT(),
			description: i18n.SELECT_CLICK_AND_COLLECT_DESC(),
		},
		{
			icon: Truck,
			title: i18n.ORDER_DELIVERED_TO_HUB(),
			description: i18n.ORDER_DELIVERED_TO_HUB_DESC(),
		},
		{
			icon: Mail,
			title: i18n.EMAIL_FOR_PICKUP(),
			description: i18n.EMAIL_FOR_PICKUP_DESC(),
		},
		{
			icon: Navigation,
			title: i18n.GO_TO_HUB(),
			description: i18n.GO_TO_HUB_PICKUP_DESC(),
		},
		{
			icon: Hand,
			title: i18n.PICK_UP_ORDER(),
			description: i18n.PICK_UP_ORDER_DESC(),
		},
	];

	return (
		<PageContainer>
			<AppHeader service="ALL" />
			<h1 className="px-6 py-2 text-2xl font-breit">
				<T>{i18n.HOW_CLICK_AND_COLLECT_WORKS()}</T>
			</h1>
			<div className="mx-6">
				{steps.map((step) => (
					<SupportStepRow key={step.title} {...step} />
				))}
			</div>
		</PageContainer>
	);
}
